import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/ICD-code-service";

export const pagingICDCodeService = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getICDCodeServiceById = (id) => axios.get(API_PATH + "/get-by-id/" + id);
export const getListByIcdCode = (id) => axios.get(API_PATH + "/get-list-by-concept-id/" + id);

export const saveOrUpdate = iCDCodeService => axios.post(API_PATH + '/save', iCDCodeService);
export const saveICDCodeListConcept = iCDCodeService => axios.post(API_PATH + '/save-icd-code-list-service', iCDCodeService);

export const deleteICDCodeService = id => axios.delete(API_PATH + '/mark-delete/' + id);

export const getAllICDCodeServices = () => axios.get(API_PATH + "/get-all")

export const getListMediReqFormByICD = (dto) => axios.post(API_PATH + '/get-list-service-by-list-icd', dto);

export const getListServiceFormByICD = (dto) => axios.post(API_PATH + '/get-list-service-by-list-icd', dto);